<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12gd7Tt/tc-custom/9781466888340.jpg?1731154772924" alt="This image is the cover for the book Eternal Party"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eternal Party
      </h1>
      <p class="bookDescription body article font2">
        <b>An intimate and revealing portrait of the TV star who played J.R. on <i>Dallas—</i>as seen through the eyes of his daughter.</b><br/><br/>When you have a very famous father, like mine, everyone thinks they know him. My dad, Larry Hagman, portrayed the ruthless oilman J.R. on the TV series <i>Dallas</i>. He was the man everyone loved to hate, but he had a personal reputation for being a nice guy who lived by his motto: DON’T WORRY! BE HAPPY! FEEL GOOD! <br/><br/>Dad had a famous parent, too—Mary Martin, best known for playing Peter Pan on Broadway. Both were beloved performers, masters of crafting their public personas. But their relationship was complex and often fraught.<br/><br/>In the hours before he died, I heard my dad beg for forgiveness, though he could not tell me what troubled him. After he died, I was compelled to learn why he felt the need to be forgiven. As I pursued the mystery of my happy-go-lucky, pot-smoking, LSD-taking dad, I came to know him—and my grandmother—better than I had known them in life.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kristina Hagman, Elizabeth Kaye
      </h2>
      
      <p class="authorDescription body article">KRISTINA HAGMAN is an artist who has been featured in the<I></I><I>Los Angeles Times, USA Today, People </I>magazine, <I>Closer </I>magazine (UK), and more. She is the daughter of Larry Hagman and granddaughter of Mary Martin and lives in Santa Monica, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c55789a2